// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"3d2c5256","322":"1b4fadc7","337":"5b488c68","379":"401fbe7e","386":"424994b7","473":"f9666c0c","488":"ffee1f91","545":"bac04a97","612":"a9717d7c","621":"520348ad","659":"22d66e9a","714":"021c5e52","857":"0a3da231","870":"90a7cbbd"}[chunkId] + ".chunk.js";
};